var __default__ = {root:'m_18320242','skeleton-fade':'m_299c329c'};
export default __default__;